import React, { useEffect } from "react";
import { Send } from "lucide-react";
import { Switch } from 'antd';

const MessageSenderMobile = ({
  value,
  header = "Send message to ChatGPT",
  onSubmit,
  onChange,
  changeDeep,
  loading = false,
  className = "",
  changeNetwork,
  networkText,
  typeMessageText,
  isCustomMade,
  isSwitch,
  isSwitchDeep
}) => {

  const [checked, setChecked] = React.useState(false);
  const [deepChecked, setDeepChecked] = React.useState(false);
  const [isComposing, setIsComposing] = React.useState(false); // 用于标识是否正在使用输入法

  useEffect(() => {
    setDeepChecked(isSwitchDeep);
  }, [isSwitchDeep]);
  
    useEffect(() => {
      setChecked(isSwitch);
      changeNetwork(isSwitch);
    }, [isSwitch]);

    const handleDeepToggle = (checked: boolean) => {
      setDeepChecked(checked);
      changeDeep(checked);
    };
  

  const handleToggle = (checked: boolean) => {
    setChecked(checked);
    changeNetwork(checked);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim()) {
      onSubmit?.(value.trim());
    }
  };

  const handleButtonClick = (e) => {
    e?.preventDefault();
    if (value.trim()) {
      onSubmit?.(value.trim());
    }
  };

  const textareaRef = React.useRef(null);

  // Auto-resize function
  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    
    // Reset height to auto to get the correct scrollHeight
    textarea.style.height = 'auto';
    
    // Calculate new height (with max-height of 200px)
    const newHeight = Math.min(textarea.scrollHeight, 200);
    textarea.style.height = `${newHeight}px`;
  };

  // Adjust height on value change
  React.useEffect(() => {
    adjustHeight();
  }, [value]);


  return (
    <div className={`w-full ${className}`}>
      <div className="bg-[#F4F4F4] p-4 rounded-3xl">
        {/* <div className="mb-2 text-gray-600 text-sm">{header}</div> */}
        <form onSubmit={handleSubmit} className="relative">
          <div className="mt-2 flex items-center">
            <textarea
              value={value}
              onChange={(e) => onChange?.(e.target.value)}
              className="flex-1 resize-none pb-2 focus:outline-none bg-transparent text-black placeholder-gray-400"
              placeholder={typeMessageText}
              onCompositionStart={() => setIsComposing(true)} // 开始输入时标记正在使用输入法
              onCompositionEnd={() => setIsComposing(false)}   // 输入结束时标记输入法已确认
              style={{
                maxHeight: '200px',
                minHeight: '24px'
              }}
              ref={textareaRef}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey && !isComposing) {
                  e.preventDefault();
                  handleButtonClick();
                }
              }}
              onBlur={() => {
                // 失去焦点时滚动到页面顶部
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 100); // 延迟确保焦点切换完成
              }}
            />
          </div>
          <div className="flex justify-between" style={ isCustomMade ? { justifyContent: 'space-between' } : {  justifyContent: 'flex-end' }}>
            <div className="flex items-center space-x-2 py-3 pt-2" style={ !isCustomMade ? { display: 'none' } : {  display: 'flex' }}>
              <div className="text-gray-600">
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                  />
                </svg>
              </div>
              <span className="text-sm text-gray-600">{networkText}</span>
              <div>
                <Switch checked={checked} onChange={handleToggle} />
              </div>
               <span className="text-sm text-gray-600">DeepThink</span>
              <div>
                <Switch checked={deepChecked} onChange={handleDeepToggle} />
              </div>
            </div>
            <button
              type="button"
              onClick={handleButtonClick}
              disabled={loading || !value.trim()}
              className="ml-2 p-2 rounded-lg bg-black hover:bg-gray-800 disabled:bg-gray-400 transition-colors"
            >
              <Send className="w-5 h-5 text-white" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MessageSenderMobile;
